import IProductImage from '../../../../common/model/IProductImage';

const carDataExtractor = {
  getImagesOfType(images: IProductImage[], type: string): IProductImage[] {
    return images.filter(image => image.type === type);
  },

  getImageSourcesFromImageList(images: IProductImage[], type?: string): string[] {
    let newImages = images;

    if (type) {
      newImages = carDataExtractor.getImagesOfType(images, type);
    }

    return newImages.map(image => image.url);
  },
};

export default carDataExtractor;
